import React, { Component } from 'react'
import { BreakItem, UserList } from '../styles/dialpadstyle'

export class CallBreakTheme extends Component {

    renderBreakName( name, el, onSelect) {
        return (
            <BreakItem onClick={()=>{
              onSelect(el);
            }}>
                {(name)}
            </BreakItem>
        )
    }
    render() {
      const { breakList, onSelect } = this.props
        return (
            <span style={{display: 'block', width: '100%'}}>
              <UserList style={{ margin: '0px -25px', width: 'auto', paddingRight: '0px' }}>
                { 
                  breakList.map(( el )=>{
                    return (
                      this.renderBreakName(
                        el.name,
                        el,
                        onSelect
                      )
                    )
                  })
                }
              </UserList>
            </span>
        )
    }
}

export default CallBreakTheme


// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/components/CallBreakTheme.js